<template>
  <div class="post-register">
    
    <post-form @save-data="saveData" :document="document" :postdata="postdata"/>
  </div>
</template>

<script>
import PostForm from "@/components/posts/PostForm.vue";

export default {
    // props:['document','postdata']
    // ,
     props: {
      document: {
        type: String,
        required: false,
        default: null
      },
      postdata: {        
        required: false,
        default: null
      },      
    },
  components: {
    PostForm,
  },
  methods: {    
    async saveData(data) {
      // for (var pair of data.entries()) 
      //   { console.log(pair[0]+ ', ' + pair[1]); }
      // //this.$router.push('/main/coaches')
      // this.$router.replace('/main/coaches')
      try {
        let response = '';
        if(data.edit){
          //수정
          response= await this.$store.dispatch("posts/updatePost", data.formData);
        }else{
          //등록
          response = await this.$store.dispatch("posts/registerPost", data.formData);
        }
        
       
       console.log('글작성후 피드백', response);
        this.$store.commit('updateUserPoint',response.user);   
         if(response.levelchange)
            {
              alert('레벨이 변경되었습니다.');
            }

        this.$flashMessage.show({
          type: response.status_code===202?"error":"info",
          title: response.message,
          message: response.message,
          //
        });
        this.$router.go(-1);
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: "유효하지 않은 데이터 입력입니다.",
              message: "유효하지 않은 데이터 입력입니다.",
            });
            break;
          case 401:
            setTimeout(() => this.$router.push("/login"), 1000);
            this.$flashMessage.show({
              type: "error",
              title: "로그인이 필요합니다.",
              //message: "로그인이 필요합니다.",
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
    },
  },
};
</script>

<style lang="scss">

.post-register {
  padding: 10px;
  border: 1px solid #dee3eb;
  background:#fff;
}
</style>
